import React, { useContext } from 'react';
import CreateProjectModalContext from '@context/Modal/create-project-modal-context';
import { useRouter } from 'next/router';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import styles from './CTA.module.scss';

export interface IWantThisLookProps {
  roomId?: number | string;
  size: string;
  className?: string;
  primaryTextClassName?: string;
  secondaryTextClassName?: string;
}

export default function WantThisLook({
  roomId,
  className,
  primaryTextClassName,
  secondaryTextClassName,
}: IWantThisLookProps) {
  const { open: openCreateProject } = useContext(CreateProjectModalContext);
  const router = useRouter();
  const theme = useTheme();

  const handleClick = () => {
    if (roomId) {
      router.push(`/rooms/${roomId}/select-package`);
    } else {
      openCreateProject({});
    }
  };

  return (
    // eslint-disable-next-line
    <div className={`${styles.CTACard} ${className || ''}`} role="button" onClick={handleClick}>
      <div className={styles.Contents}>
        <div>
          <img
            className={styles.Icon}
            src={'/static/images/explore/cta-want-look-avatar.png'}
            alt={''}
          />
          <div className={
            classnames(theme.styles.Title2, styles.PrimaryText, primaryTextClassName)
          }
          >
            Want this look?
          </div>
          <div className={classnames(styles.SecondaryText, secondaryTextClassName)}>
            Start a design today.
          </div>
        </div>
        <div className={ styles.Overlay } />
      </div>
    </div>
  );
}
